import styled, { keyframes } from 'styled-components';
import { Card } from '../styles/OverviewStyle';

const shimmer = keyframes`
   0% { background-position: -468px 0; }
   100% { background-position: 468px 0; }
`;

const SkeletonBox = styled.div`
   background: linear-gradient(to right, #F0F0F2 8%, #E7E7E9 18%, #F0F0F2 33%);
   background-size: 800px 104px;
   animation: ${shimmer} 1.5s linear infinite;
   border-radius: 6px;
`;

const SkeletonTitle = styled(SkeletonBox)`
   height: 14px;
   width: 60%;
   margin-bottom: 12px;
`;

const SkeletonValue = styled(SkeletonBox)`
   height: 32px;
   width: 80%;
   margin-bottom: 8px;
`;

const SkeletonMeta = styled(SkeletonBox)`
   height: 10px;
   width: 40%;
`;

export default function SkeletonCard(): React.JSX.Element {
   return (
      <Card>
         <SkeletonTitle />
         <SkeletonValue />
         <SkeletonMeta />
      </Card>
   );
}
